import { ChapterList } from './ChapterList'
import { withChapterList } from './withChapterList'

const ConnectedChapterList = withChapterList(ChapterList)

export { ConnectedChapterList as ChapterList }
